import { render, staticRenderFns } from "./CategoryInformation.vue?vue&type=template&id=0a3b2426&scoped=true&"
import script from "./CategoryInformation.vue?vue&type=script&lang=js&"
export * from "./CategoryInformation.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInformation.vue?vue&type=style&index=0&id=0a3b2426&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b2426",
  null
  
)

export default component.exports